module.exports = __webpack_public_path__ + "media/bootstrap-icons/menu-down-b03eb144.svg";